import { ScrollingModule } from '@angular/cdk/scrolling';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { LcsResponsiveTableModule } from '@lcs/shared/table';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { RegisterModule } from 'src/app/common-components/register/register.module';
import { FormatMailboxTypesPipeModule } from 'src/app/pipes/format-mailbox-types-pipe/format-mailbox-types-pipe.module';
import { MailboxRegisterComponent } from './containers/mailbox-register.component';
import { MailboxRegisterEffects } from './state/mailbox-register.effects';
import { mailboxRegisterFeatureKey, mailboxRegisterReducer } from './state/mailbox-register.reducer';
import { MailboxRegisterViewComponent } from './views/mailbox-register-view.component';

@NgModule({
   declarations: [MailboxRegisterComponent, MailboxRegisterViewComponent],
   imports: [
      CommonModule,
      FormsModule,
      LcsCallStatePipeModule,
      LcsLoadingOverlayModule,
      LcsResponsiveTableModule,
      MatButtonModule,
      MatInputModule,
      MatTooltipModule,
      MatIconModule,
      ReactiveFormsModule,
      RouterModule,
      MatMenuModule,
      RegisterModule,
      ScrollingModule,
      FormatMailboxTypesPipeModule,
      EffectsModule.forFeature([MailboxRegisterEffects]),
      StoreModule.forFeature(mailboxRegisterFeatureKey, mailboxRegisterReducer),
   ],
})
export class MailboxRegisterModule {}
